import styled from "styled-components";

const TableWrap = styled.div`
   margin-top: 8px;
`;

const TableHeadRow = styled.div`
   display: grid;
   grid-template-columns: 1fr 1.2fr 1fr 1fr 1fr 1fr 1fr 1.2fr;
   padding: 12px 0;
   border-bottom: 1px solid #E7E7E9;
   font-size: 12px;
   letter-spacing: -0.025em;
   color: #B3B3B6;
`;

const TableRow = styled.div`
   display: grid;
   grid-template-columns: 1fr 1.2fr 1fr 1fr 1fr 1fr 1fr 1.2fr;
   padding: 14px 0;
   font-size: 14px;
   letter-spacing: -0.025em;
   border-bottom: 1px solid #F1F1F3;
   align-items: center;
`;

const Badge = styled.span<{ variant?: 'success' | 'pending' | 'failed' }>`
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 4px 10px;
   font-size: 12px;
   font-weight: 500;
   letter-spacing: -0.025em;
   border-radius: 99px;
   background: rgba(192, 34, 54, 0.08);
   color: #C02236;
   font-family: ui-monospace, "SF Mono", monospace;
   ${({ variant }) => variant === 'success' && 'background: rgba(16, 205, 35, 0.08); color: #10CD23;'}
   ${({ variant }) => variant === 'pending' && 'background: rgba(255, 166, 0, 0.08); color: #FFA600;'}
   ${({ variant }) => variant === 'failed' && 'background: rgba(221,82,77,0.08); color: #DD524D;'}

   &::before {
      content: '';
      width: 4px;
      height: 4px;
      border-radius: 9999px;
      background: ${({ variant }) => variant === 'pending' ? '#FFA600' : variant === 'failed' ? '#DD524D' : variant === 'success' ? '#10CD23' : '#C02236'};
   }
`;

const MonoSmall = styled.span`
   font-family: ui-monospace, "SF Mono", monospace;
   font-size: 12px;
   color: #6D6D72;
`;

const MonoUsername = styled(MonoSmall)`
   background: #F6F6F6;
   border-radius: 99px;
   width: min-content;
   padding: 3px 8px;
`

export {
   Badge,
   MonoSmall,
   MonoUsername, TableHeadRow,
   TableRow, TableWrap
};
